<template>
  <el-dialog
    title="Initiate a new Discussion"
    :visible="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <el-form :model="form" label-width="120px">
      <el-form-item label="Title: ">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Description: ">
        <MarkdownEdit :value="form.description" @input="updateDescription" withMaxHeight />
      </el-form-item>
      <el-form-item label="Attachment: ">
        <el-upload
          action=""
          :limit="1"
          :fileList="fileList"
          :on-change="handleFileAppend"
          :on-remove="handleFileRemove"
          :auto-upload="false"
        >
          <el-button slot="trigger" type="primary">Select File...</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hideDialog">Discard</el-button>
      <el-button type="primary" @click="handleSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MarkdownEdit from "@/atoms/MarkdownEdit.vue";
import { postDiscussion } from "@/api";

export default {
  name: "DiscussionPublishForm",
  props: {
    dialogVisible: Boolean
  },
  components: {
    MarkdownEdit
  },
  data() {
    return {
      fileList: [],
      form: {
        name: "",
        description: "",
      }
    };
  },
  methods: {
    updateDescription(value) {
      this.form.description = value;
    },
    clearForm() {
      this.form = {
        name: "",
        description: "",
      };
      this.fileList = [];
    },
    hideDialog() {
      this.clearForm();
      this.$emit("update:dialogVisible", false);
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleFileAppend(file, fileList) {
      this.fileList = fileList;
    },
    handleSubmit() {
      if (this.$store.state.classId) {
        const { name, description } = this.form;
        const classId = this.$store.state.classId;
        const teacherId = this.$store.state.userId;
        let attachment = "";
        if (this.fileList.length > 0) {
          attachment = this.fileList[0].raw;
        }
        postDiscussion(
          name,
          description,
          classId,
          teacherId,
          attachment
        ).then(res => {
          if (res && res.id) {
            this.hideDialog();
            this.$emit("refresh-list");
            this.$message({
              type: "success",
              message: "Discussion Initiated!"
            });
          }
        });
      }
    },
    handleClose() {
      this.$confirm("Discard Changes?")
        .then(() => {
          this.hideDialog();
        })
        .catch(() => {});
    }
  }
};
</script>

<style>
</style>